import { render, staticRenderFns } from "./RunNewsletter.vue?vue&type=template&id=4513d866&"
import script from "./RunNewsletter.vue?vue&type=script&lang=ts&"
export * from "./RunNewsletter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports